import axios from 'axios';
import AffiliateHubLogger from '../util/affiliate-hub-logger';
import { PzOauthErrorCodes } from './server-error-codes';
import { Logger } from 'bernie-logger';
import { SuccessResponse } from 'client/success-response';
import { FailureResponse } from 'client/failure-response';

const GRANT_TYPE = 'authorization_code';

export class PzOAuthSource {
  private logger: AffiliateHubLogger;

  public constructor(logger: Logger) {
    this.logger = new AffiliateHubLogger(logger);
  }

  public async getAccessToken(authorizationCode: string, userEmail: string) {
    try {
      const response = await axios.post('/api/v1/pz/oauth/access_token', {
        code: authorizationCode,
        grantType: GRANT_TYPE,
        userEmail,
      });

      if (response.data.success) {
        return Promise.resolve(new SuccessResponse(response.data.body));
      }

      return Promise.reject(response.data);
    } catch (ex) {
      this.logger.error('FAILED_TO_FETCH_ACCESS_TOKEN', ex);
      // this condition makes sure that response received has been handled and massaged properly on the BFF.
      // Else its something unexpected.
      if (ex.response?.data?.success !== undefined) {
        return Promise.reject(ex.response.data);
      }

      return Promise.reject(new FailureResponse(PzOauthErrorCodes.UNKNOWN, ex.response));
    }
  }

  public async getNewAccessToken(refreshToken: string, email: string) {
    try {
      const response = await axios.post('/api/v1/pz/oauth/refresh_token', { refreshToken, email });
      if (response.data.success) {
        return Promise.resolve(new SuccessResponse(response.data.body));
      }

      return Promise.reject(response.data);
    } catch (ex) {
      this.logger.error('FAILED_TO_REFETCH_ACCESS_TOKEN', ex);
      // this condition makes sure that response received has been handled and massaged properly on the BFF.
      // Else its something unexpected.
      if (ex.response?.data?.success !== undefined) {
        return Promise.reject(ex.response.data);
      }

      return Promise.reject(new FailureResponse(PzOauthErrorCodes.UNKNOWN, ex.response));
    }
  }
}
